export const MARKETING_JSON_URL = "https://instances.vantage.sh/marketing.json";
